import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubmissionHistory } from 'src/app/model/submission-history';

import { ScreenSizeService } from 'src/app/services/screen-size.service';
// Start: CAP-39922 DMBR-64
import { CacheService } from 'src/app/services/cache.service';
import { DIMBO_CONSTANT } from 'src/app/utils/constant';
// End: CAP-39922 DMBR-64

/**
 * Displays submission history and emits current vehicle info.
 */
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit, OnChanges {
  @Input() searchResults: SubmissionHistory[] = [];
  @Input() loading: boolean = false;
  @Input() errorMessage: string = '';
  /** CAP-39922 DMBR-64: When true, show current contract badge (VIN search only). */
  @Input() isVinSearch: boolean = false;
  @Input() hasSearched: boolean = false;
  // Start: CAP-39922 DMBR-64
  @Input() submissionMode: boolean = false;
  @Input() isCentralUser: boolean = false;
  // End: CAP-39922 DMBR-64
  @Output() vehicleInfoChange = new EventEmitter<any>();

  isMobile: boolean = false;
  isTablet: boolean = false;
  // Start: CAP-39922 DMBR-64
  private locale: string = '';
  // End: CAP-39922 DMBR-64

  constructor(private screenSizeService: ScreenSizeService,
    // Start: CAP-39922 DMBR-64
    private cacheService: CacheService
    // End: CAP-39922 DMBR-64
  ) {

  }

  ngOnInit(): void {
    this.screenSizeService.screenWidth$.subscribe((width) => {
      this.isMobile = width <= 480;
      this.isTablet = width > 480 && width <= 768;
    });

    // Start: CAP-39922 DMBR-64
    this.locale = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LOCALE) || '';
    // End: CAP-39922 DMBR-64

    // Determine and set the current contract for the displayed contracts (searchResults or fallback)
    this.emitCurrentVehicleInfo();
  }

  ngOnChanges() {
    this.emitCurrentVehicleInfo();
  }

  emitCurrentVehicleInfo() {

    const contracts = this.displayContracts;
    if (contracts && contracts.length > 0) {
      const current = contracts.find(c => c.isCurrentContract) || contracts[0];
      this.vehicleInfoChange.emit({ ...current, isFromSearch: true , shouldUpdateVehicleInfo: true}); // Add flag
    } 
  }


  get displayContracts() {
    return this.searchResults && this.searchResults.length > 0 ? this.searchResults : [];
  }

  // Start: CAP-39922 DMBR-64
  /** Map brand short code to full display name. OV => Vauxhall in en_GB, else Opel. */
  getFullBrandName(shortCode: string): string {
    switch (shortCode) {
      case 'AP': return 'Peugeot';
      case 'AC': return 'Citroen';
      case 'DS': return 'DS';
      case 'OV': return this.locale === 'en_GB' ? 'Vauxhall' : 'Opel';
      default: return shortCode;
    }
  }
  // End: CAP-39922 DMBR-64

}
